import { render, staticRenderFns } from "./RankChangeConfirm.vue?vue&type=template&id=8671b0ae&"
import script from "./RankChangeConfirm.vue?vue&type=script&lang=js&"
export * from "./RankChangeConfirm.vue?vue&type=script&lang=js&"
import style0 from "./RankChangeConfirm.vue?vue&type=style&index=0&id=8671b0ae&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports